import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-two-six-one',
  templateUrl: './two-six-one.component.html',
  styleUrls: ['./two-six-one.component.scss']
})
export class TwoSixOneComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 2/2.6.1 CO PO file GNKC YNR.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
